module.exports = __webpack_public_path__ + "e0b65a722935fec39ac09e216427e421.svg";